<div class="page-config-icon">
  <scw-mat-small-button (onClick)="filterVisibilityButtonClicked()">
    <em class="fas fa-filter"></em>
    {{ isFilterBarVisible ? 'Hide Filters' : 'Show Filters'  }}
  </scw-mat-small-button>
</div>
